import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStore from '../../store';
import { NavigationEnd, Router, ActivatedRoute, NavigationCancel } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { trigger, style, transition, animate } from '@angular/animations';
import { LangList, PackageList, urlPath, OAuthPurposeType, updateInfoType, OAuthPlatformType, CheckAuthOtpErrMsg,
         AuthOtpType } from '../../shareModel';
import { environment, Confirm_button } from '../../../environments/environment';
import { OAuthLoginMessage } from '../../shareModel';
import { AccountOauthParam, AccountOauthSWParam } from '../../my-features/account/oauth.model';
import * as fromFeature from '../../my-features';
import { AccountService } from '../../services/account.service';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  standalone: false,
  selector: 'app-sw-social-login',
  templateUrl: './sw-social-login.component.html',
  styleUrls: ['./sw-social-login.component.css'],
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('.3s', style({ opacity: 1 }))
      ]),
    ])
  ]
})
export class SWSocialLoginComponent implements OnInit, OnDestroy {
  private componentDestroyed = new Subject();
  state: string;
  platform: string;
  AddOauthparam: AccountOauthParam = {
    Code: '',
    RegisterSys: 1,
    RegisterType: 0,
    Purpose: OAuthPurposeType.AddAccountFromSW
  };
  AddAccountOauthSWParam: AccountOauthSWParam = {
    UId: '',
    Platform: 0,
    PId: '',
    SW: '',
    ExpiredTimeStamp: 0,
    Email: ''
  };
  TwoFactorAuthDialog = false;
  socialEmailRegisterSetting = false;
  socialAccountEmailAlert = false;
  socialAccountCombineLimitAlert = false;
  censoredEmail: any;
  LoginLocked = false;
  LoginLockedMessage: string;
  AuthOtpId: number;
  AuthUserotp: string;
  message: string;
  OTPNumber: string;
  OTPLockDialog = false;
  OTPOvertime = false;
  errorMsg = '';
  errorMsgByLock = false;
  OTPNumberSubmitDisabled = true;
  dialogSaveDirty = false;
  Country = null;
  Confirm_button = Confirm_button;
  CountryOptions = [
    { label: TRANSLATE('Select Country'), value: null }
  ];
  config = {
    leftTime: 300,
    template: '$!m!:$!s!',
  };
  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, private apiService: AccountService,
              private router: Router) {
    this.store.select(fromStore.getOauthLogin).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.Loaded && !res.Loading) {
        if (!res.entities.Flag) {
          if (Number(res.entities.Message) === OAuthLoginMessage.AddAccountAvailable) {
            this.AddOauthparam = {
              ...this.AddOauthparam,
              Platform: res.entities.Platform,
              PId: res.entities.PId,
              Email: res.entities.Email,
              FirstName: res.entities.FirstName,
              LastName: res.entities.LastName,
              app: res.entities.app,
              time: res.entities.time,
              uid: res.entities.uid,
            };
            this.socialEmailRegisterSetting = true;
            // this.registerAccountWithSocial();
          } else if (Number(res.entities.Message) === OAuthLoginMessage.HasAnotherPlatform) {
            this.socialAccountCombineLimitAlert = true;
          } else if (Number(res.entities.Message) === OAuthLoginMessage.SameEmailExist) {
            this.socialAccountEmailAlert = true;
            this.censoredEmail = res.entities.Email;
          }
          if (res.entities.Message.toString().includes('lock')) {
            this.LoginLockedMessage = res.entities.Message.toString();
            this.LoginLocked = true;
          }
        } else {
          this.ngxService.stop();
          console.log('success! window.close');
          // window.close();
        }
      }
    });

    this.store.select(fromStore.getAccountOauthSWParam).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded) {
        this.AddAccountOauthSWParam = {
          ...this.AddAccountOauthSWParam,
          UId: res.entities.UId,
          Platform: res.entities.Platform,
          PId: res.entities.PId,
          SW: res.entities.SW,
          ExpiredTimeStamp: res.entities.ExpiredTimeStamp,
          Email: res.entities.Email,
        };
      }
    });

    this.store.select(fromStore.getAuthotp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        if (res.entities !== undefined) {
          if (res.entities.Flag) {
            this.TwoFactorAuthDialog = true;
            this.AuthOtpId = res.entities.Id;
            this.AuthUserotp = res.entities.otp;
          } else {
            this.OTPLockDialog = true;
          }
        }
        this.ngxService.stop();
      } else if (!res.Loaded && res.Loading) {
        if (res.entities !== undefined) {
          this.message = res.entities.message;
        }
      }
    });

    this.store.select(fromStore.getCheckAuthOtp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        if (res.entities.Flag) {
          if (this.AddAccountOauthSWParam.UId !== '') {
            this.store.dispatch(new fromFeature.AddAccountOauthSW({ ...this.AddAccountOauthSWParam }));
          }
          this.TwoFactorAuthDialog = false;
          // window.close();
        } else {
          this.errorMsg = CheckAuthOtpErrMsg[res.entities.Message];
          if (res.entities.Message === '1' || res.entities.Message === '2') {
            this.OTPOvertime = true;
            if (res.entities.Message === '1') {
              this.errorMsgByLock = true;
            }
            this.ngxService.stop();
          }
          this.dialogSaveDirty = true;
          this.ngxService.stop();
        }
      }
    });
   }

  ngOnInit() {
    this.ngxService.start();
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-help');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    this.apiService.ReadCountryList().subscribe(res => {
      if (res !== null) {
        const opt = res.map(function (e) {
          return { label: e, value: e };
        });
        this.CountryOptions = this.CountryOptions.concat(opt);
      }
    });
    this.ngxService.stop();
  }

  registerAccountSettingSave() {
    this.socialEmailRegisterSetting = false;
    this.AddOauthparam = {
      ...this.AddOauthparam,
      Country: this.Country,
    };
    this.store.dispatch(new fromFeature.AddAccountByOauth({ ...this.AddOauthparam }));
    // if (true) {
    //   console.log(this.Country);
    //   console.log('用該AFG帳號新增一個PPC帳號');
    //   this.messageService.add({ severity: 'success', summary: 'You have logged in with the social account successfully!' });
    //   this.socialEmailRegisterSetting = false;
    // }
  }

  registerAccountSettingCancel() {
    this.socialEmailRegisterSetting = false;
    // window.close();
  }

  checkRegisterAccountSave() {
    if (!this.Country) {
      return true;
    }
    return false;
  }

  handleEvent(e) {
    if (e.left <= 0) {
      this.errorMsg = CheckAuthOtpErrMsg[2];
      this.OTPOvertime = true;
    }
  }

  closeDialog() {
    this.socialEmailRegisterSetting = false;
    this.TwoFactorAuthDialog = false;
    this.OTPLockDialog = false;
    // window.close();
  }

  OTPkeyupEnter(e) {
    if (this.OTPNumber.length >= 6) {
      this.confrimOTPnumber();
    }
  }

  OTPNumberOnchange($event) {
    const OTPNumberLength = $event.replaceAll('_', '');
    if (OTPNumberLength.length >= 6) {
      this.OTPNumberSubmitDisabled = false;
    } else {
      this.OTPNumberSubmitDisabled = true;
    }
  }

  confrimOTPnumber() {
    this.ngxService.start();
    const param = {
      otp: this.AuthUserotp,
      authId: Number(this.AuthOtpId),
      authType: AuthOtpType.LoginSW,
      authOtp: this.OTPNumber,
    };
    this.store.dispatch(new fromFeature.CheckAuthOtp(param));
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
